export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#3AB4B7',
    light: '#e5f2fa',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#F2A546',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(247, 247, 247, 0.5)',
  background: {
    main: '#277678',
    card: '#FAFAEE',
    paper: '#FFF',
    default: '#FFF',
    header: '#E6F3F5',
    footer: 'rgba(230, 243, 245, 0.5)',
    level2: '#f7f8fb',
    level1: 'rgba(255, 255, 255, 0.6)',
    steps: '#3AB4B7',
    tableHead: '#277678',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#0A2727',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: 'linear-gradient(to right, #A0B6BC, #D9E1DD)',
    secondary: 'rgb(240,243,243)',
    light: '#ebe8e7',
    arrow: '#BACE60',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#020202',
    unused: '#e5e5e5',
    unlimited: '#C0C0C0',
  }
};